import { render } from "./ConfPolicy.vue?vue&type=template&id=84efd448"
import script from "./ConfPolicy.vue?vue&type=script&lang=js"
export * from "./ConfPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__